import types from '../types';
import API from '../../../lib/api';
import ModalsLib from '../../../lib/modals';
import {toast} from 'react-toastify';

export const createOrder = data => async dispatch => {
    // Disable button and clear error
    dispatch({
        type: types.paypal_deposit.updateStageData,
        payload: {
            error: null,
            ...data, // Save new data
            button: true
        }
    });

    // Make API request
    const response = await API.call({
        path: '/payments/client/paypal_merchant/deposit/createOrder',
        method: 'POST',
        body: data
    });

    if(!response.success) {
        dispatch({
            type: types.paypal_deposit.updateStageData,
            payload: {
                error: response.error,
                button: false
            }
        });
    } else {
        dispatch({
            type: types.paypal_deposit.order,
            payload: response.order
        });

        dispatch({
            type: types.paypal_deposit.updateStageData,
            payload: {
                button: false
            }
        });

        dispatch({
            type: types.paypal_deposit.setStage,
            payload: 'confirm'
        });
    }
}

export const setStage = stage => {
    return {
        type: types.paypal_deposit.setStage,
        payload: stage
    }
}
